@if(content){
<div class="flex flex-middle m-b">
    <div class="ratio-1-1"
         style="width: 36px">
        <img class="rf"
             [image]="content?.image">
    </div>
    <div class="p-l-2"
         style="width: calc(100% - 36px);">
        <href class="p2"
              [link]="content?.copyLink">{{variant | translate}}
            @if (content?.ctaText && content?.copyLink && !content?.showCta) {
            <span class="b-b b-w-2 b-col-4"
                  style="padding-bottom: 3px;"
                  *iCms="'ctaText' of content"></span>
            }
        </href>
        @if (content?.ctaText && content?.showCta) {
        <button class="p2 b-b b-w-2 b-col-4"
                [iCmsModalOpen]="findOutMoreModalId"
                [iCmsModalVariant]="variant">
            <span *iCms="'ctaText' of content"></span>
        </button>
        }
    </div>
</div>
}
